import {
  MAIN_BLUE,
  MAIN_DEEP_BLACK,
  MAIN_DEEP_BLUE,
  NO_THEME_RED,
  MAIN_GOLD,
  MAIN_GREEN_RISE,
  MAIN_RED_FALL,
  MAIN_DEEP_WHITE,
  NO_THEME_GREY,
  MAIN_DARK,
  GRAY_484848,
  DARK_232323,
  GRAY_7d7d7d,
  DARK_282828,
  DARK_1F2121,
  DARK_2c2e2e,
  MAIN_PRIMARY,
  THEME,
  DARK_BG,
  DARK_CARD_BORDER,
  WHITE_BG,
  DARK_LINE,
  GRAY_414747,
  DARK_191D1D,
  GRAY_222525,
} from "../../constants/colors";

const defaultDarkColorConfig = {
  H00: MAIN_DEEP_WHITE,
  H01: GRAY_7d7d7d,
  H02: GRAY_484848,
  H03: MAIN_DEEP_BLUE,
  H04: MAIN_DARK,
  H05: MAIN_DEEP_BLACK,
};

const DARK_THEME = {
  theme: THEME.DARK,
  ...defaultDarkColorConfig,
  common_gold: MAIN_GOLD,
  common_blue: MAIN_BLUE,
  common_rise: MAIN_BLUE,
  common_fall: NO_THEME_RED,
  common_bgc: GRAY_484848,
  container_bg: MAIN_DEEP_BLACK,
  content_bg: MAIN_DEEP_BLUE,
  content_bg_special: DARK_282828,
  content_bg_active: MAIN_DEEP_BLUE,
  text_white: MAIN_DEEP_WHITE,
  text_white_2: MAIN_DEEP_WHITE,
  text_white_3: MAIN_DEEP_WHITE,
  text_white_5: MAIN_DEEP_WHITE,
  text_reverse_white: MAIN_DEEP_WHITE,
  text_grey: GRAY_7d7d7d,
  text_grey_active: MAIN_DEEP_WHITE, //FIX
  text_thin_title: GRAY_7d7d7d,
  text_thin_border: NO_THEME_GREY,
  card_header_bg: MAIN_DARK,
  card_header_bg_disabled: GRAY_484848,
  card_header_text: MAIN_DEEP_WHITE,
  grey_border: MAIN_DARK,
  gery_bg: GRAY_484848,
  depth_bg_green: MAIN_GREEN_RISE,
  depth_bg_red: MAIN_RED_FALL,
  kline_button_text: GRAY_7d7d7d,
  kline_button_text_selected: MAIN_DEEP_WHITE,
  kline_button_bg_selected: MAIN_PRIMARY,
  plain_select_bg_active: MAIN_DEEP_BLACK,
  plain_select_text: MAIN_DEEP_WHITE,
  plain_select_text_active: MAIN_BLUE,
  card_split: GRAY_484848,
  colored_span_bg: MAIN_DEEP_BLUE,
  colored_span_border: MAIN_BLUE,
  leverage_block_bg: MAIN_DEEP_BLUE,
  leverage_block_border: MAIN_DARK,
  leverage_block_border_rise: MAIN_BLUE,
  leverage_block_border_fall: NO_THEME_RED,
  leverage_block_text: MAIN_BLUE,
  tab_header_active: MAIN_DEEP_WHITE,
  vs_bg_rise: MAIN_BLUE,
  vs_text_rise: MAIN_DEEP_WHITE,
  vs_bg_fall: NO_THEME_RED,
  vs_text_fall: MAIN_DEEP_WHITE,
  standalone_table_header_text: GRAY_7d7d7d,
  inner_table_header_text: GRAY_7d7d7d,
  input_bg: MAIN_DEEP_BLUE,
  input_bg_disabled: GRAY_484848,
  input_border: MAIN_DEEP_BLACK,
  input_border_disabled: GRAY_484848,
  input_text: MAIN_DEEP_WHITE,
  input_addon: GRAY_414747,
  special_input_bg: MAIN_DEEP_BLUE,
  side_span_text: GRAY_7d7d7d,
  side_span_bg: MAIN_DEEP_BLUE,
  percent_span_text: GRAY_7d7d7d,
  percent_span_bg: MAIN_DEEP_BLUE,
  percent_span_text_active: MAIN_BLUE,
  percent_span_bg_active: MAIN_DEEP_WHITE,
  radio_inner_border: NO_THEME_GREY,
  span_thin_border: GRAY_484848,
  common_table_row_text: MAIN_DEEP_WHITE,
  entrust_type_tab_background: MAIN_DEEP_BLUE,
  entrust_type_tab_border: MAIN_DEEP_BLUE,
  condition_wrapper: DARK_232323,
  header_bgc: MAIN_DEEP_BLUE,
  dropdown_bgc: DARK_282828,
  dropdown_menu_new: DARK_1F2121,
  dropdown_menu_new_hover: DARK_1F2121,
  dropdown_menu: DARK_191D1D,
  dropdown_list_hover_bg: GRAY_222525,
  dropdown_list_hover_new: DARK_2c2e2e,
  dropdown_menu_text: MAIN_DEEP_WHITE,
  language_border: GRAY_484848,
  new_dropdown_list_hover_bg: "#3D4249",
  language_boxshadow: MAIN_DEEP_BLACK,
  login_btn: MAIN_DEEP_WHITE,
  kline_time_text: "#E4E7EC",
  kline_time_title: "#7D7D7D",
  kline_time_hover_text: "#27AEC0",
  kline_time_hover_bgc: "#222525",
  scroll_bar_alpha: GRAY_484848,
  table_header_bg: DARK_BG,
  table_header_border: DARK_CARD_BORDER,
  line_content_bg: MAIN_DEEP_BLUE,
  line_content_border: "#222525",
  line_start: "#656E6F",
  kline_time_text_color: WHITE_BG,
  line_color: DARK_LINE,
};
export default DARK_THEME;
